import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './sections/Hero';
import About from './sections/About';
import FAQ from './sections/FAQ';
import Services from './sections/Help';
import Contact from './sections/Contact';
import Subscription from './sections/Subscription';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import CancellationRefund from './pages/CancellationRefund';
import ShippingDelivery from './pages/ShippingDelivery';
import Disclaimer from './pages/Disclaimer';
import HowItWork from './pages/HowItWork';
import Safety from './pages/Safety';
import AccountDeletion from './pages/AccountDeletion';
import SosTerms from './pages/SosTerms';
import SectionDivider from "./components/SectionDivider";


// import QRScanner from './components/QRScanner';
import ScrollToTop from './components/ScrollToTop';
import Hero1 from './pages/Hero1';

function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Header />
      <main>
        <Routes>
          {/* Home route with all sections */}
          <Route
            path="/"
            element={
              <>
                <section id="hero"><Hero /></section>
                     

                <section id="about"><About /></section>
                  

                 <section id="services"><Services /></section>
                      

                <section id="faq"><FAQ /></section>
                      

                {/* <section id="services"><Services /></section> */}
                <section id="contact"><Contact /></section>
              </>
            }
          />

          {/* Individual pages */}
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/support" element={<Contact />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cancellation-refund" element={<CancellationRefund />} />
          <Route path="/shipping-delivery" element={<ShippingDelivery />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route path="/sos-terms" element={<SosTerms />} />
       
        </Routes>
      </main>
      {/* <QRScanner /> */}
      <Footer />
    </Router>
  );
}

export default App;

